import Swal from "sweetalert2";
import { isSafeAreaDisplay } from "@/service/IsSafeAreaDisplay";

export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  target: "wrapper",
  showConfirmButton: false,
  showCloseButton: true,
  timer: 3000,
  timerProgressBar: true,
  padding: isSafeAreaDisplay() ? "50px 1.25rem 1.25rem 1.25rem" : "1.25rem",
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
